<template>
	<div class="app-container">
	  
	  <div class="topView">
        <el-descriptions title="订单详情" direction="horizontal" :column="4" border>
            <el-descriptions-item label="订单编号">{{datas.productOrderCode}}</el-descriptions-item>
            <el-descriptions-item label="下单时间">{{datas.createTime}}</el-descriptions-item>
            <el-descriptions-item label="支付方式">{{datas.payType == 2 ? '支付宝' : '微信'}}</el-descriptions-item>

            <el-descriptions-item label="订单状态" v-if="datas.productOrderStatus == 'pending_pay'">待支付</el-descriptions-item>
            <el-descriptions-item label="订单状态" v-else-if="datas.productOrderStatus == 'paid'">已支付</el-descriptions-item>
            <el-descriptions-item label="订单状态" v-else-if="datas.productOrderStatus == 'pending_send'">待发货</el-descriptions-item>
            <el-descriptions-item label="订单状态" v-else-if="datas.productOrderStatus == 'shipped'">已发货</el-descriptions-item>
            <el-descriptions-item label="订单状态" v-else-if="datas.productOrderStatus == 'in_transit'">运输中</el-descriptions-item>
            <el-descriptions-item label="订单状态" v-else-if="datas.productOrderStatus == 'delivered'">已签收</el-descriptions-item>
            <el-descriptions-item label="订单状态" v-else-if="datas.productOrderStatus == 'completed'">已完成</el-descriptions-item>
            <el-descriptions-item label="订单状态" v-else-if="datas.productOrderStatus == 'closed'">已关闭</el-descriptions-item>
            <el-descriptions-item label="订单状态" v-else-if="datas.productOrderStatus == 'refunding'">退款中</el-descriptions-item>
            <el-descriptions-item label="订单状态" v-else-if="datas.productOrderStatus == 'refunded'">已退款</el-descriptions-item>
            <el-descriptions-item label="订单状态" v-else-if="datas.productOrderStatus == 'except'">异常订单</el-descriptions-item>

            <el-descriptions-item label="商品总价">{{'¥'+subtract(datas.orderPrice,datas.freightPrice)}}</el-descriptions-item>
            <el-descriptions-item label="配送费">{{'¥'+ datas.freightPrice}}</el-descriptions-item>
            <el-descriptions-item label="订单金额">{{'¥'+ datas.orderPrice}}</el-descriptions-item>
            
            <el-descriptions-item label="收货人">{{userAddrInfo.contactName}}</el-descriptions-item>
            <el-descriptions-item label="收货地址">{{userAddrInfo.contactAddrDetail}}</el-descriptions-item>
            <el-descriptions-item label="手机号">{{userAddrInfo.contactPhone}}</el-descriptions-item>
        </el-descriptions>
      </div>

      <div class="middleView" style="margin-top: 20px;">
        <el-table :data="goodsList" border>
            <el-table-column prop="productId" label="编号" width="100" align="center">
            </el-table-column>
            <el-table-column prop="productName" label="商品名称" width="350" align="center"></el-table-column>
            <el-table-column label="商品图片" width="120" align="center">
                <template slot-scope="scope">
                    <el-image :src="scope.row.imageList[0].imageUrl"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="价格" width="120" align="center">
                <template slot-scope="scope">
                    <p>价格：￥{{scope.row.productPrice}}</p>
                </template>
            </el-table-column>
        </el-table>
      </div>

      <div class="bottomView" style="margin-top: 20px; display: flex; justify-content: flex-end;">
        
        <div v-if="datas.productOrderStatus === 'pending_pay'">
            <el-button
                size="mini"
                type="default"
                @click="backPage()">返回
            </el-button>
            <el-button
                size="mini"
                type="danger"
                @click="handleDelProduct(datas.row)">删除
            </el-button>
        </div>
        <div v-else-if="datas.productOrderStatus === 'pending_send'">
            <el-button
                size="mini"
                type="default"
                @click="backPage()">返回
            </el-button>
            <el-button
                size="mini"
                type="danger"
                @click="handleDelProduct(datas.row)">删除
            </el-button>
        </div>
        <div v-else-if="datas.productOrderStatus === 'refunding'" style="display: flex; justify-items: center;">
            <el-button
                size="mini"
                type="default"
                @click="backPage()">返回
            </el-button>
            <el-button
                size="mini"
                type="primary"
                @click="handleRefund(datas.row)">确认退款
            </el-button>
            <el-button
                size="mini"
                type="danger"
                @click="handleNoRefund(datas.row)">拒绝退款
            </el-button>
        </div>
      </div>
	  
	</div>
</template>

<script>
    export default  {

        data(){
        
            return{
                datas:{},
                userAddrInfo:{},
                goodsList:[]
            }
        },
        mounted() {
            
            this.getOrderDetail();
        },
        methods:{

            subtract(a, b) {

                return a - b;
            },
            getOrderDetail(){
	  	  
                let paramter = {
                    'productOrderCode':this.$route.query.orderCode
                };
                this.$http.get("product/order/code", {params:paramter}).then((res) => {
                    
                    this.datas = res.data.data;
                    this.userAddrInfo = this.datas.userAddrInfo;
                    this.goodsList = this.datas.productList;
                });
            },

            // 返回按钮
            backPage(){

                this.$router.back();
            }
        }
    }
</script>

<style scoped>

</style>